import React, { FC, useCallback } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { StepLayout } from 'components/StepLayout/StepLayout';
import { SiteSetupStepProgress } from 'steps/site-setup/components/SiteSetupStepProgress';
import { useSiteSetup } from 'hooks/useSiteSetup';
import { useOrchestratorNavigation } from '@wix/gg-common-lib/orchestrator';
import { SiteSetupStepErrorState } from './components/SiteSetupStepErrorState';
import { biEvents } from 'api/bi-events';
import { BI_STEP_NAME } from 'config/bi-events';
import { StepId } from 'config/flow';

export const SiteSetupStep: FC = () => {
  const { t } = useTranslation();
  const { next } = useOrchestratorNavigation();

  const { isSuccess, isError, refetch } = useSiteSetup({
    onError: (error) => {
      biEvents.errorState({
        screen: BI_STEP_NAME[StepId.SiteSetup],
        data: JSON.stringify(error),
      });
    },
  });

  const renderContent = useCallback(() => {
    if (isError) {
      return <SiteSetupStepErrorState onTryAgain={refetch} />;
    }

    return <SiteSetupStepProgress shouldComplete={isSuccess} onComplete={next} />;
  }, [isError, isSuccess, refetch, next]);

  return (
    <StepLayout
      hideActions
      description={t('site-setup-step.progress.description')}
      title={t('site-setup-step.progress.title')}
    >
      {renderContent()}
    </StepLayout>
  );
};
